var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHacienda(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 37,
    viewBox: "0 0 194 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M167.446 13H154V26.8793H167.446L172.217 22.542V18.2047L167.446 13Z",
    fill: "#CF1463"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55 29.5L61.0722 16.0361L61.9396 13L69.5 29.5H55Z",
    fill: "#CF1463"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M175 29.5L181.072 16.0361L181.94 13L189.5 29.5H175Z",
    fill: "#CF1463"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 25.5H20V29.5H0V9.5H4V25.5Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28 13.5H24V5.5H28V13.5Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36 21.5V29.5H32V9.5H36V17.5H48V9.5H52V29.5H48V21.5H36Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53 29.5L63 8.5L73 29.5H68.5L63 18L57.5 29.5H53Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5938 25.5H91.5938V29.5H81.5938C78.8229 29.5 76.4583 28.5312 74.5 26.5938C72.5625 24.6354 71.5938 22.2708 71.5938 19.5C71.5938 16.7292 72.5625 14.375 74.5 12.4375C76.4583 10.4792 78.8229 9.5 81.5938 9.5H91.5938V13.5H81.5938C79.9271 13.5 78.5104 14.0833 77.3438 15.25C76.1771 16.4167 75.5938 17.8333 75.5938 19.5C75.5938 21.1667 76.1771 22.5833 77.3438 23.75C78.5104 24.9167 79.9271 25.5 81.5938 25.5Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5 29.5H94.5V9.5H98.5V29.5Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M122.938 21.5H111.938V17.5H122.938V21.5ZM122.938 9.5V13.5H106.938V25.5H122.938V29.5H102.938V9.5H122.938Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M130.719 15.5V37H126.719V9.5H130.719L142.719 23.5V0H146.719V29.5H142.719L130.719 15.5Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M165.156 29.5H151.156V9.5H165.156C167.927 9.5 170.281 10.4792 172.219 12.4375C174.177 14.375 175.156 16.7292 175.156 19.5C175.156 22.2708 174.177 24.6354 172.219 26.5938C170.281 28.5312 167.927 29.5 165.156 29.5ZM155.156 25.5H165.156C166.823 25.5 168.24 24.9167 169.406 23.75C170.573 22.5833 171.156 21.1667 171.156 19.5C171.156 17.8333 170.573 16.4167 169.406 15.25C168.24 14.0833 166.823 13.5 165.156 13.5H155.156V25.5Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M173.781 29.5L183.781 8.5L193.781 29.5H189.281L183.781 18L178.281 29.5H173.781Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHacienda);
export default __webpack_public_path__ + "static/media/hacienda.c58892c4fdbe75b0bc7c5effe2d7d6ba.svg";
export { ForwardRef as ReactComponent };